import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Select, Table, TableBody, TableCell, TableHead, TableRow}  from '@material-ui/core';
import {Paper, MenuItem, IconButton, ListItemText} from '@material-ui/core';

import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import { getObjectByID } from '../../../api/helpers';


class ExternalGroupsList_ extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
            //licenses: this.props.licenses,
            menuAnchor: null, 
            menuItem: '',
            selected: '',

            //externalGroups: []
        }

        this.handleRemoteServerSelect = this.handleRemoteServerSelect.bind(this)
        this.handleRemoteNetworkSelect = this.handleRemoteNetworkSelect.bind(this)


        this.handleRemoteGroupSelect = this.handleRemoteGroupSelect.bind(this)

        //this.loadExternalGroups = this.loadExternalGroups.bind(this)

        //this.props.onAction({type:'REGISTER_LOAD_EXTERNAL_GROUPS_CALLBACK', callback: this.loadExternalGroups})

    }

    /*
    loadExternalGroups(localNetworkID, localGroupID){
        console.log('loadExternalGroups() '+ localNetworkID + ' ' + localGroupID)

        let externalGroups = this.getExternalGroups(this.props.serverSettings, localNetworkID, localGroupID) 

        console.log(externalGroups)

        this.setState({externalGroups, externalGroups})
    }
    */
    /*
    getExternalGroups(serverSettings, networkID, groupID){

        let externalGroupList = []

        //alert('getExternalGroupsList')
        //console.log('getExternalGroupsList')
        //console.log(serverSettings)

        serverSettings.LinkedServers.forEach(linkedServer=>{

            linkedServer.GroupMap.forEach((groupMap, index) => {

                if(groupMap.ExternalNetworkId==networkID && groupMap.ExternalGroupId==groupID){

                    externalGroupList.push({
                        ExternalServerId: linkedServer.ServerLink.ID,
                        ExternalGroupId: groupMap.ExternalGroupId,
                        ExternalNetworkId: groupMap.ExternalNetworkId,
                        groupMapIndex: index
                    })

                }

            })

        })


        return externalGroupList

    }
    */

    getRowStyle(id){
        //let selected = id === this.state.selected
        //console.log('ServerGroupMapList_.getRowStyle '+id + ' =? '+ this.state.selected)
        let selected = id === this.state.selected
        let style = {
            background: selected? theme.palette.background.selectedRow : '',
            cursor: 'pointer'
        }
        return style
    }

    handleItemSelect(id){
        this.setState({selected: id})
        //this.props.onAction({type: 'SELECT_CURRENT_SERVER', externalServerID: id})
    }

    handleDeleteItem(index){
        this.props.onAction({
            type: 'GROUP_MAP_DELETE', 
            externalServerID: this.props.currentServer.ServerLink.ID, 
            index: index
        })
        //alert('delete '+index)
    }

    getNetworks(externalServerID){

        //console.log('getNetworks ' + externalServerID + '         ###############################')

        if(!externalServerID) return []

        let externalServer = this.props.onAction({type: 'GET_EXTERNAL_SERVER', externalServerID: externalServerID})
        //console.log(externalServer)

        if(externalServer) {
            //console.log(externalServer.RemoteServerObjects.Networks)
            return externalServer.RemoteServerObjects.Networks
        }

        return []
    }

    getGroups(serverId, networkID){

        let networks = this.getNetworks(serverId)

        let network = getObjectByID(networkID, networks)

        if(network) return network.Groups

        return []
    }

    handleRemoteServerSelect(event, mapIndex, oldServerID){     
        this.props.onAction({type:'SET_EXTERNAL_SERVER_ID', index: mapIndex, value: event.target.value} )
    }

    handleRemoteNetworkSelect(event, mapIndex){
        this.props.onAction({type:'SET_EXTERNAL_NETWORK_ID', index: mapIndex, value: event.target.value} )
    }

    handleLocalGroupSelect(event, mapIndex){
        this.props.onAction({type:'SET_LOCAL_GROUP_ID', index: mapIndex, value: event.target.value} )
    }

    handleRemoteGroupSelect(event, mapIndex){
        this.props.onAction({type:'SET_EXTERNAL_GROUP_ID', index: mapIndex, value: event.target.value} )
    }

    handleMenuItemClick(menu){

        if(menu==='GROUP_MAP_ADD'){

            this.props.onAction({type:'GROUP_MAP_ADD'} )

        }

    }

    getServerName(serverID, servers){
        let server = getObjectByID(serverID, this.props.externalServers)
        return server ? server.Name : '' 
    }

    getNetworkName(networkID, serverID){

        let networks = this.getNetworks(serverID)

        let network = getObjectByID(networkID, networks)
        return network ? network.Name : '' 
    }

    getGroupName(groupID, networkID, networks){
        let network = getObjectByID(networkID, networks)
        if(network){
            let group = getObjectByID(groupID, network.Groups) 
            return group ? group.Name : '' 
        } 
        return ''
    }

    getTableRow(groupMap, index){

        //console.log('getTableRow ' + index)
        //console.log(groupMap)

        let server = getObjectByID(groupMap.ExternalServerId, this.props.externalServers)
        let serverName = server ? server.Name : '' 

        let networks = this.getNetworks(groupMap.ExternalServerId)
        let network = getObjectByID(groupMap.ExternalNetworkId, networks)
        let networkName = network ? network.Name : '' 

        let groupName = ''
        if(network){
            let group = getObjectByID(groupMap.ExternalGroupId, network.Groups) 
            groupName = group ? group.Name : '' 
        }


        return(
<TableRow key={index+' '+groupMap.LocalGroupId+'_'+groupMap.ExternalGroupId} 
            onClick={()=>{this.handleItemSelect(index)}}
            style={this.getRowStyle(index)}>

    <TableCell component="th" scope="row">{serverName}</TableCell>
    <TableCell component="th" scope="row">{networkName}</TableCell>
    <TableCell component="th" scope="row">{groupName}</TableCell>

</TableRow>

        )
    }

    render(){
        const {t} = this.props

        //console.log('render Server Links List')
        //console.log(this.props)

        //this.state.licenses.sort(sortByName)

        const styles = {
            paper: {
              width: '100%',
              overflowX: 'auto',
              marginLeft: 16
            },
            head: {
                color: theme.palette.color.dialogTitle,
                backgroundColor: theme.palette.background.dialogTitle,
            },
            addIcon: {
                color: 'white'
            }
        }

        return(
            <>
                <Paper style={styles.paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalServer')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalNetwork')}</TableCell>
                                <TableCell colSpan={1} style={styles.head}>{t('ExternalGroup')}</TableCell>
                                {/*
                                <TableCell style={{...styles.head, width:40}}>
                                    <IconButton size="small" color="primary" aria-label="more" component="span"
                                        style={styles.addIcon}
                                        disabled={!this.props.currentServer}
                                        onClick={()=>{this.handleMenuItemClick('GROUP_MAP_ADD')}}>
                                        <AddCircleOutlineIcon />
                                    </IconButton>
                                </TableCell>
                                */}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {this.props.externalGroups ? this.props.externalGroups.map((groupMap, index) => 
                            this.getTableRow(groupMap, index)
                        ):null}


                            {/*
                            <TableRow key={index+' '+groupMap.LocalGroupId+'_'+groupMap.ExternalGroupId} 
                                    onClick={()=>{this.handleItemSelect(index)}}
                                    style={this.getRowStyle(index)}>

                                <TableCell component="th" scope="row">
                                    {this.getServerName(groupMap.ExternalServerId)}
                                    
                                    <SelectServer 
                                        name='ExternalServerId'
                                        mapIndex={index}
                                        serverID={groupMap.ExternalServerId}
                                        servers={this.props.externalServers}
                                        onSelect={this.handleRemoteServerSelect}  
                                    />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                    {this.getNetworkName(groupMap.ExternalNetworkId, groupMap.ExternalServerId)}
                                    <SelectNetwork 
                                        name='ExternalNetworkId'
                                        mapIndex={index}
                                        networkID={groupMap.ExternalNetworkId}
                                        //currentServer={this.props.currentServer}
                                        networks={this.getNetworks(groupMap.ExternalServerId)} 
                                        //onSelect={this.handleRemoteNetworkSelect}
                                    />
                                </TableCell>

                                <TableCell component="th" scope="row">
                                     { this.getGroupName(groupMap.ExternalServerId, groupMap.ExternalNetworkId) }
                                    <SelectGroup 
                                        name='ExternalGroupId'
                                        mapIndex={index}
                                        networkID={groupMap.ExternalNetworkId}
                                        groupID={groupMap.ExternalGroupId}
                                        groups={this.getGroups(groupMap.ExternalServerId, groupMap.ExternalNetworkId)}
                                        //currentServer={this.props.currentServer}
                                        //onSelect={this.handleRemoteGroupSelect}
                                    />
                                </TableCell>

                                <TableCell style={{width:40}}>
                                    <IconButton size="small" color="inherit" aria-label="more" component="span"
                                        disabled={!this.props.currentServer}
                                        onClick={event=>this.handleDeleteItem(index)}>
                                        <DeleteForeverIcon/>
                                    </IconButton>
                                </TableCell>
                                
                                
                            </TableRow>
                            */}

                        </TableBody>

                    </Table>    
                </Paper>
            </>
        )

    }

}

class SelectServer extends React.Component{

    checkError(){

        if(!this.props.serverID){
            return(true)
        }

        if(this.props.serverID && this.props.servers){
            let exists = false
            this.props.servers.forEach(server => {
                if(server.ID===this.props.serverID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }


    render(){

        //console.log('render SelectNetwork '+ this.props.mapIndex)
        //console.log(this.props.networks)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        //console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.serverID?this.props.serverID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex, this.props.serverID)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.servers.map(server => (
                    <MenuItem key={server.ID} value={server.ID}>{server.Name}</MenuItem>
                ))}
            </Select>
        )

    }

}

class SelectNetwork extends React.Component{

    checkError(){

        if(!this.props.networkID){
            return(true)
        }

        if(this.props.networkID){
            let exists = false
            this.props.networks.forEach(net => {
                if(net.ID===this.props.networkID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }


    render(){

        //console.log('render SelectNetwork '+ this.props.mapIndex)
        //console.log(this.props.networks)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        //console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.networkID?this.props.networkID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.networks.map(net => (
                    <MenuItem key={net.ID} value={net.ID}>{net.Name}</MenuItem>
                ))}
            </Select>
        )

    }

}

class SelectGroup extends React.Component{


    checkError(){

        if(!this.props.groupID){
            return(true)
        }

        if(this.props.groupID){
            let exists = false
            this.props.groups.forEach(group => {
                if(group.ID===this.props.groupID){
                    exists = true
                }
            })

            if(!exists) return true

        }

        return false
    }



    render(){

        //console.log('render SelectGroup '+ this.props.mapIndex)
        //console.log(this.props.groups)
        //console.log(this.props.currentServer)

        let error = this.checkError()
        ///console.log(error)

        return(
            <Select 
                style={{minWidth: 180}}
                error={error}
                value={this.props.groupID?this.props.groupID:''}
                onChange={event=>{
                    this.props.onSelect(event, this.props.mapIndex)
                }}
                inputProps={{
                    name: this.props.name,
                    id: this.props.name,
                }}
                >

                {this.props.groups.map(group => (
                    <MenuItem key={this.props.networkID+'_'+group.ID} value={group.ID}>{group.Name}</MenuItem>
                ))}
            </Select>
        )

    }

}

export const ExternalGroupsList = withTranslation()(ExternalGroupsList_);